import { useI18nContext } from "@hopper-b2b/i18n";
import "./styles.scss";
import dayjs from "dayjs";
import {
  secondsToDays,
  secondsToHours,
  HOURS_IN_A_DAY,
} from "@hopper-b2b/utilities";
import { useMemo } from "react";
import { TimeToLive } from "@b2bportal/price-freeze-api";

const DATE_FORMAT = "MMM DD, YYYY";

export interface IPriceFreezeOfferCard {
  message?: string;
  frozenFlightPrice: string;
  priceFreezePrice: string;
  priceFreezeSecondsTtl: number;
  children?: JSX.Element;
  isOnConfirmation?: boolean;
  priceFreezeTtl?: TimeToLive;
}

export const PriceFreezeOfferCard = (props: IPriceFreezeOfferCard) => {
  const { t } = useI18nContext();
  const {
    message,
    frozenFlightPrice,
    priceFreezePrice,
    priceFreezeSecondsTtl,
    children,
    isOnConfirmation,
    priceFreezeTtl,
  } = props;

  //Added plus one to fix calcualted duration
  const secondToHours0 = secondsToHours(priceFreezeSecondsTtl) + 1;
  const secondsToDays0 = secondsToDays(priceFreezeSecondsTtl) + 1;
  const calculatedPriceFreezeDuration =
    secondToHours0 < HOURS_IN_A_DAY
      ? `${secondToHours0} ${t("priceFreezePurchase.offerCard.hours")}`
      : `${secondsToDays0} ${
          secondsToDays0 === 1
            ? t("priceFreezePurchase.offerCard.day")
            : t("priceFreezePurchase.offerCard.days")
        }`;

  const priceFreezeDuration: string =
    priceFreezeTtl?.inDays && priceFreezeTtl?.inDays >= 1
      ? `${priceFreezeTtl?.inDays} ${
          priceFreezeTtl?.inDays === 1
            ? t("priceFreezePurchase.offerCard.day")
            : t("priceFreezePurchase.offerCard.days")
        }`
      : priceFreezeTtl?.inHours
      ? `${priceFreezeTtl?.inHours} ${t("priceFreezePurchase.offerCard.hours")}`
      : calculatedPriceFreezeDuration;

  const priceFreezeExipresOn = dayjs()
    .add(priceFreezeSecondsTtl || 0, "s")
    .format(DATE_FORMAT);

  const durationText = useMemo(
    () =>
      isOnConfirmation
        ? `${t("priceFreezePurchase.offerCard.freezeDurationConfirmationTitle")}
        ${priceFreezeDuration}`
        : `${t("priceFreezePurchase.offerCard.freezeDurationTitle")}`,
    [isOnConfirmation, priceFreezeDuration, t]
  );

  return (
    <div className="checkout-price-freeze-offer-card">
      {message ? <div className="title">{message}</div> : null}
      <div className="offer-info-card">
        <div className="offer-info-data">
          <div className="offer-info-title">
            {t("priceFreezePurchase.offerCard.frozenPrice")}
          </div>
          <div className="offer-info-price">{frozenFlightPrice}</div>
        </div>
        <div className="offer-info-data">
          <div className="offer-info-title">
            {t("priceFreezePurchase.offerCard.costOfFreeze")}
          </div>
          <div className="offer-info-price">{priceFreezePrice}</div>
        </div>
      </div>
      <div className="duration-text">{durationText}</div>
      <div className="expire-text">
        {t("priceFreezePurchase.offerCard.expiresOn")} {priceFreezeExipresOn}
      </div>
      {children}
    </div>
  );
};
